/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useRef, useLayoutEffect } from "react";
import { TestId } from "./TestId";
import { useForkRef } from "@smartsheet/lodestar-utils";
export var VirtualizedListItem = function (_a) {
    var _b;
    var children = _a.children, treeItemData = _a.treeItemData, indentPerTreeLevel = _a.indentPerTreeLevel, virtualRow = _a.virtualRow, onItemClick = _a.onItemClick, onItemContextMenu = _a.onItemContextMenu, onItemMouseEnter = _a.onItemMouseEnter, onItemMouseLeave = _a.onItemMouseLeave, isExpanded = _a.isExpanded, isSelected = _a.isSelected, listItemRef = _a.listItemRef, tabIndex = _a.tabIndex, onItemFocus = _a.onItemFocus;
    var virtualizedListElementRef = useRef(null);
    var updateDimensions = function () {
        virtualRow.measureRef(virtualizedListElementRef.current);
    };
    /**
     * Changes to the dimensions of the VirtualizedListItemContainer are reported to the VirtualizedList component. This is required
     * to handle scenarios that cause the list item height to increase/decrease like:
     *  - Folder expand/collapse
     */
    useLayoutEffect(function () {
        // This call is required for the initial render of the list item to appropriately adjust the height. List items do
        // not have a fixed height. Their default height is set to ESTIMATED_LIST_ITEM_SIZE which is set in the parent component.
        // After initial render the dynamic height can then be used instead of ESTIMATED_LIST_ITEM_SIZE
        updateDimensions();
    });
    var itemClick = function (event) {
        event.stopPropagation();
        onItemClick(treeItemData, event);
    };
    var itemRightClick = function (event) {
        event.stopPropagation();
        onItemContextMenu && onItemContextMenu(treeItemData, event);
    };
    var itemMouseEnter = function (event) {
        onItemMouseEnter && onItemMouseEnter(treeItemData, event);
    };
    var itemMouseLeave = function (event) {
        onItemMouseLeave && onItemMouseLeave(treeItemData, event);
    };
    var leftIndentBasedOnLevel = indentPerTreeLevel * ((_b = treeItemData.level) !== null && _b !== void 0 ? _b : 0);
    /**
     * Combine the 2 refs, 1 for virtualization and other to manage the focus
     */
    var combinedRef = listItemRef
        ? useForkRef(virtualizedListElementRef, listItemRef)
        : virtualizedListElementRef;
    var handleOnFocus = function (event) {
        onItemFocus(virtualRow.index, event);
    };
    return (jsx("li", { css: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            listStyleType: "none",
            position: "absolute",
            top: 0,
            left: leftIndentBasedOnLevel,
            width: "calc(100% - ".concat(leftIndentBasedOnLevel, "px)"),
            transform: "translateY(".concat(virtualRow.start, "px)"),
            "&:focus": {
                outline: "none"
            }
        }, "data-testid": TestId.LI_ELEMENT, ref: combinedRef, role: "row", "aria-expanded": isExpanded, "aria-selected": isSelected, "aria-current": isSelected ? "page" : false, "aria-level": treeItemData.level, "aria-setsize": treeItemData.sizeOfSet, "aria-posinset": treeItemData.positionInSet, onMouseEnter: itemMouseEnter, onMouseLeave: itemMouseLeave, onClick: itemClick, onFocus: handleOnFocus, onContextMenu: itemRightClick, tabIndex: tabIndex }, children));
};
//# sourceMappingURL=VirtualizedListItem.js.map